type SessionContinuityCheck = () => boolean;

let check: SessionContinuityCheck = () => false;

export const setSessionContinuityCheck = (
	nextCheck: SessionContinuityCheck
): void => {
	check = nextCheck;
};

// Named for the indirection, not the answer — the real implementation lives in
// @gov-nx/web and is registered above. Sharing its name would let a consumer
// import the wrong one and silently get the unregistered default.
export const runSessionContinuityCheck = (): boolean => check();
